/**
 * This file is a single entry point to import the visual library. It just imports the visual library with a given
 * flavor and theme just once, and the rest of the files of this project can import the visual library without having
 * to know the concrete flavor and theme they are using. This helps a lot when for some reason a developer needs to
 * change the import of the visual library from, let's say, web flavor to bs flavor. Having this file, the change only
 * involves updating this file, while on the other hand the developer would need to change all the files where the
 * visual library is imported one by one.
 */
export * from "starz-visual-library/dist/starz-visual-library.bs.webos.1280";
